<template>
  <div class="dptSettingContainer">
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      @open="open"
      @opened="opened"
      :before-close="handleClose"
      @closed="closed"
      :modal="false"
      :append-to-body="true"
      custom-class="setting-workFlow"
      size="600"
    >
      <div slot="title" class="titleContianer" :class="workFlowStyles.nameBg">
        <div class="workFlowName">
          <svg-icon :icon-class="workFlowStyles.nameIcon"></svg-icon>
          <input ref="nameInput" type="text" :disabled="!canFocus" v-model="workFlowProcess.name" />
        </div>
      </div>

      <SheetBg
        v-if="workFlowProcess.type == 'workFlowStart'"
        :triggerType="workFlowProcess.trigger.type"
      ></SheetBg>

      <!-- <div v-if="requestLoading" v-loading="requestLoading" class="content-empty"></div> -->

      <div
        v-loading="requestLoading"
        class="content"
        ref="scrollWrapper"
        v-ps
        :class="{
          'content-normal': workFlowProcess.type != 'workFlowStart',
          'content-short': workFlowProcess.type == 'workFlowStart'
        }"
      >
        <ding-group
          v-if="setting.includes('dingGroup')"
          ref="dingGroup"
          :flowConnectedData="flowConnectedData"
          :workflow-var-group-string="workflowVarGroupString"
          :workFlowData="workFlowData"
          :workFlowProcess="workFlowProcess"
          :inputData="dingGroupData"
        ></ding-group>
        <top-tip v-if="setting.includes('topTip')" :nodeInfo="workFlowProcess"></top-tip>

        <div v-if="setting.includes('btnTrigger')" class="btn-info">
          <div class="row">
            <b>工作表:</b>
            {{ sheetInfo.name }}
          </div>
          <div class="row">
            <b>按钮:</b>
            <el-tag>{{ workFlowProcess.trigger.sheetBtn.name }}</el-tag>
          </div>
          <div class="row">
            <b>按钮描述:</b>
            {{ workFlowProcess.desc }}
          </div>
        </div>

        <div v-if="setting.includes('validateTrigger')" class="contentItem">
          <div class="itemTitle">工作表</div>
          <div style="margin-top: 10px">{{ sheetInfo.name }}</div>
        </div>

        <div v-if="setting.includes('dataSource')" class="contentItem">
          <div class="itemTitle">数据源:</div>
          <div style="padding-top: 10px;">
            <span>{{ dataSource }}</span>
          </div>
        </div>

        <div v-if="setting.includes('selectVar')" class="contentItem">
          <div class="itemTitle">选择数据对象</div>
          <tree-select
            class="item-select"
            v-model="selectedVar"
            :group-list="workflowVarGroupControlTypeRef"
            @input="changeExtra"
          ></tree-select>
        </div>

        <div v-if="setting.includes('workFlowTrigger')" class="contentItem">
          <div class="itemTitle">被以下工作流触发:</div>
          <template v-if="workFlows.length">
            <div v-for="workFlow in workFlows" :key="workFlow.id" style="padding-top:10px;">
              <div class="workFlows">
                <div class="workFlowsTipsBtn" @click="editMainWorkFlow(workFlow.id)">
                  {{ workFlow.name }}
                </div>
                <span>节点</span>
                <span style="font-weight: bold">
                  {{ '"' + workFlow.itemNameStr.replace(",", '" , "') + '"' }}
                </span>
                <span>触发</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="margin-top: 10px">
              <span>未被任何工作流触发</span>
            </div>
          </template>
        </div>

        <div v-if="setting.includes('params')" class="contentItem">
          <div class="itemTitle">数据对象入参:</div>
          <!--          当存在refSheetId时，显示父流程信息-->
          <div
            v-if="workFlowProcess.trigger.control.refSheetId"
            class="output-sheet"
            style="margin-top: 10px"
          >
            <span v-for="workFlow in workFlows" :key="workFlow.id">
              {{ "[工作表] " + dataSource }}
            </span>
          </div>
          <output-params
            v-else-if="!_.isEmpty(subParams)"
            ref="subParam"
            :output-params="subParams"
          ></output-params>
        </div>

        <div v-if="setting.includes('extraInput')" class="contentItem">
          <div class="itemTitle">自定义入参:</div>
          <script-key-value-paris
            :list="extraInput"
            :controls="controls"
            from="list"
            addItemText="+ key-value pairs"
          ></script-key-value-paris>
        </div>

        <!-- 查找 单条/多条 -->
        <div v-if="setting.includes('oneFlag')" class="contentItem">
          <div class="itemTitle">查找条数</div>
          <el-radio-group v-model="oneFlag" class="mTop10" @change="changeExtra">
            <el-radio :label="true">单条</el-radio>
            <el-radio :label="false">
              多条
              <el-tooltip effect="dark" placement="bottom">
                <div slot="content">
                  从一个指定工作表的视图中得到符合条件
                  <br />
                  的批量数据（最多不超过100条），供流
                  <br />
                  程中的计算节点批量操作。
                </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-radio>
          </el-radio-group>
        </div>
        <!-- 查找 单条/多条 End -->

        <!-- 选择工作表 -->
        <div v-if="setting.includes('selectSheet')" class="contentItem">
          <div class="itemTitle">
            选择工作表
            <span class="require-flag">*</span>
          </div>
          <NormalSelect
            size="normal"
            filterable
            style="margin-top: 10px"
            :selectList="allSheet | translateAllSheet"
            :selectedItem.sync="selectedSheet"
            @update:selectedItem="changeTriggerExtra"
          ></NormalSelect>
        </div>
        <!-- 选择工作表 End -->

        <!-- 触发方式 -->
        <div v-if="setting.includes('trigger')" class="contentItem trigger">
          <div class="itemTitle">触发方式</div>
          <el-radio-group
            v-model="operateType"
            class="radioList"
            @change="changeOperateType"
            :disabled="radioDisable"
          >
            <el-radio label="CU" :class="{ mBottom30: operateType === 'CU' }">
              <span>新增或更新记录时</span>
              <div v-if="operateType === 'CU'" class="tips">
                <div v-if="!specifiedField">
                  新增记录或任意字段更新时触发，设为
                  <span class="tipsBtn" @click="specifiedField = true">指定字段触发</span>
                </div>
                <div v-else>
                  新增记录或任意字段更新时触发
                  <span
                    class="tipsBtn"
                    @click="
                      specifiedField = false
                      selectedFields = []
                    "
                  >
                    清除
                  </span>
                </div>
              </div>
            </el-radio>
            <NormalSelect
              v-if="operateType === 'CU' && specifiedField"
              :multiple="true"
              :selectList="sheetInfo | translateSheetFieldsSub(controlTypeMap)"
              :selectedItem.sync="selectedFields"
              @changeState="changeState"
              filterable
            ></NormalSelect>
            <el-radio label="C" :class="{ mBottom30: operateType === 'C' }">
              <span>新增记录时</span>
              <div v-if="operateType === 'C'" class="tips">
                新增记录时都会触发
              </div>
            </el-radio>
            <el-radio label="U" :class="{ mBottom30: operateType === 'U' }">
              <span>更新记录时</span>
              <div v-if="operateType === 'U'" class="tips">
                <div v-if="!specifiedField" style="line-height: 20px;">
                  任意字段更新时都会触发，设为
                  <span class="tipsBtn" @click="specifiedField = true">指定字段触发</span>
                </div>
                <div v-else>
                  仅当以下任意一个字段更新时触发
                  <span
                    class="tipsBtn"
                    @click="
                      specifiedField = false
                      selectedFields = []
                    "
                  >
                    清除
                  </span>
                </div>
              </div>
            </el-radio>
            <NormalSelect
              v-if="operateType === 'U' && specifiedField"
              :multiple="true"
              :selectList="sheetInfo | translateSheetFieldsSub(controlTypeMap)"
              :selectedItem.sync="selectedFields"
              @changeState="changeState"
              filterable
            ></NormalSelect>
          </el-radio-group>
        </div>
        <!-- 触发方式 End -->

        <div v-if="setting.includes('inputCornstr')" class="contentItem">
          <div class="itemTitle">
            输入定时触发日期的cron表达式
            <span class="require-flag">*</span>
          </div>
          <el-input v-model="cronStr" class="mTop10" @blur="changeTriggerExtra"></el-input>
        </div>

        <div v-if="setting.includes('delayStr')" class="contentItem">
          <div class="itemTitle">输入延时表达式</div>
          <el-input v-model="delayStr" class="mTop10" @blur="changeExtra"></el-input>
        </div>

        <div v-if="setting.includes('setSubProcessRes')" class="contentItem">
          <div class="itemTitle">输出参数</div>
          <tree-select
            class="item-select"
            v-model="expresion"
            :group-list="workflowVarGroup"
            @input="changeExtra"
          ></tree-select>
        </div>

        <!-- 选择节点对象 -->
        <div v-if="setting.includes('selectTarget')" class="contentItem">
          <div class="itemTitle">选择节点对象</div>
          <div class="titleTip" style="margin-bottom: 10px">当前流程中的节点对象</div>
          <tree-select
            :group-list="workflowVarGroupControlTypeRef"
            v-model="selectedTarget"
            @input="changeExtra"
          ></tree-select>
        </div>
        <!-- 选择节点对象 End -->

        <!-- 选择 添加/移除 参与人 -->
        <div v-if="setting.includes('participants')" class="contentItem">
          <div class="itemTitle">
            添加/移除参与人？
          </div>
          <el-radio-group v-model="isAdd" style="margin-top: 16px" @change="changeExtra">
            <el-radio :label="true" border size="small" style="margin-right: 14px">
              添加
            </el-radio>
            <el-radio :label="false" border size="small">移除</el-radio>
          </el-radio-group>
        </div>
        <!-- 选择 添加/移除 参与人 End -->

        <!-- 选择人员（单个） -->
        <div v-if="setting.includes('selectPerson')" class="contentItem">
          <div v-if="workFlowProcess.type == 'UserVerify'" class="itemTitle">
            选择审批发起人
          </div>
          <div v-else class="itemTitle">选择人员</div>
          <select-scope
            title="选择人员"
            :multiple="false"
            :var-group="flowConnectedData | screenPeople"
            :show-department-tab="false"
            show-user-tab
            v-model="verifyOriginator"
          ></select-scope>
        </div>

        <!-- 选择人员（多个） -->
        <div v-if="setting.includes('selectPeople')" class="contentItem">
          <!-- 选择参与人时，不能切换至选择角色 -->
          <template v-if="workFlowProcess.type == 'ServiceSetPart'">
            <div class="itemTitle" style="margin-bottom: 10px">要添加/移除的参与人</div>
            <select-scope
              title="选择人员"
              multiple
              :var-group="flowConnectedData | screenPeople"
              :show-department-tab="false"
              show-user-tab
              v-model="selectedPeople"
            ></select-scope>
          </template>
          <template v-else>
            <div v-if="selectPeopleBy == 'people'" class="itemTitle">
              选择{{ peopleLabel }}
              <span class="itemSubTitle" @click="getRoles">切换至根据角色选择</span>
            </div>
            <div v-else-if="selectPeopleBy == 'role'" class="itemTitle">
              选择角色
              <span class="itemSubTitle" @click="selectPeopleBy = 'people'">
                切换至根据人员选择
              </span>
            </div>
            <div v-if="selectPeopleBy == 'people'">
              <select-scope
                title="选择人员"
                multiple
                :var-group="flowConnectedData | screenPeople"
                :show-department-tab="false"
                show-user-tab
                v-model="selectedPeople"
              ></select-scope>
            </div>
            <div v-else-if="selectPeopleBy == 'role'">
              <NormalSelect
                v-loading="loadingRoles"
                :selectList="allRoles | translateAllRoles"
                :selectedItem.sync="selectedRole"
              ></NormalSelect>
            </div>
          </template>
        </div>
        <!-- 选择人员 End -->

        <!-- 选择字段 -->
        <div v-if="setting.includes('selectField')" class="contentItem">
          <div class="itemTitle">选择字段</div>
          <NormalSelect
            :selectList="sheetInfo | translateSheetFields"
            :selectedItem.sync="selectedField"
          ></NormalSelect>
        </div>
        <!-- 选择字段 End -->

        <!-- 指定日期字段 -->
        <div v-if="setting.includes('selectTimeField')" class="contentItem">
          <div class="itemTitle">
            指定日期字段
            <span class="require-flag">*</span>
          </div>
          <div class="titleTip">将按照此字段的日期作为日期表来触发流程</div>
          <NormalSelect
            size="normal"
            :selectList="sheetInfo | screenTimeField"
            :selectedItem.sync="selectedTimeField"
            @handle-select="selectTimeField"
            @update:selectedItem="changeTriggerExtra"
          ></NormalSelect>
        </div>
        <!-- 指定日期字段 End -->

        <!-- 指定执行时间 -->
        <div v-if="setting.includes('selectExecuteTime') && selectedTimeField" class="contentItem">
          <div class="itemTitle">
            执行时间
            <span class="require-flag">*</span>
          </div>
          <ExecuteTime :executeTime="executeTime" @change="changeTriggerExtra"></ExecuteTime>
        </div>
        <!-- 指定执行时间 End -->

        <!-- 触发条件 -->
        <div v-if="setting.includes('triggerCondition')" class="contentItem">
          <div class="itemTitle">触发条件</div>
          <div class="titleTip">设置筛选条件后，满足条件的数据才会进入流程</div>
          <condition-list
            from="sheet_backend"
            :conditions="filters"
            :search-sheet="sheetInfo"
            :rely-sheet="sheetInfo"
            size="normal"
          ></condition-list>
        </div>
        <!-- 触发条件 -->

        <!-- 并发控制 -->
        <template v-if="setting.includes('parallel')">
          <div class="contentItem">
            <div class="itemTitle">高级设置</div>
            <div class="titleTip">在一定条件下，同时触发工作流</div>
            <el-checkbox
              :value="limitType === 'NONE'"
              @input="changeLimitType"
              style="margin-top: 10px"
            >
              允许同时执行工作流
            </el-checkbox>
            <div v-if="limitType !== 'NONE'">
              <div class="itemTitle">条件设置</div>
              <el-radio-group v-model="limitType" class="radioList">
                <el-radio label="WORKFLOW">
                  <span>任意数据</span>
                </el-radio>
                <el-radio label="SHEET_DATA">
                  <span>同一条数据</span>
                </el-radio>
                <el-radio label="DATA_FIELD">
                  <span>当不同数据的指定字段相同时</span>
                </el-radio>
              </el-radio-group>
              <NormalSelect
                v-if="limitType == 'DATA_FIELD'"
                multiple
                :selectList="sheetInfo | translateSheetFieldsSub(controlTypeMap)"
                :selectedItem.sync="limitCids"
                @changeState="changeState"
                filterable
              ></NormalSelect>
            </div>
          </div>
          <div class="contentItem" v-if="limitType !== 'NONE'">
            <div class="itemTitle">等待时长</div>
            <div class="titleTip">若前一条工作流在等待时长内结束，则开始执行后一条工作流</div>
            <el-input
              v-model="waitSecond"
              placeholder="请输入内容"
              style="margin: 10px 5px 10px 0;width: 95%"
              type="number"
              min="0"
            ></el-input>
            秒
          </div>
        </template>
        <!-- 触发条件 End -->

        <!-- 更新字段 -->
        <div v-if="setting.includes('updateFields')" class="contentItem">
          <update-fields
            ref="updateFields"
            :updateFields.sync="updateFields"
            :group-list="workflowVarGroup"
            :update-data="workFlowProcess.data"
            :sheet-list="workflowVarGroupControlTypeRef"
            :extra="workFlowProcess.extra"
            :control-type-map="controlTypeMap"
          ></update-fields>
        </div>
        <!-- 更新字段 End -->

        <set-seal
          v-if="setting.includes('setSeal')"
          ref="setSeal"
          :group-list="workflowVarGroup"
          :data="workFlowProcess.data"
          :extra="workFlowProcess.extra"
        ></set-seal>

        <!-- 选择 人员 -->
        <set-people
          v-if="setting.includes('setPeople')"
          ref="SetPeople"
          multiple
          :from="workFlowData.type == 'task' ? 'Project' : 'App'"
          :people-group="flowConnectedData | screenPeople"
          name="通知人员"
          :flow-info="workFlowProcess"
          :project-id="appId"
          :app-id="appId"
        ></set-people>
        <!-- 选择 人员 -->

        <!-- 审批、通知、查找内容 -->
        <div v-if="setting.includes('inputTextarea')" class="contentItem">
          <div class="itemTitle">
            通知内容
            <span class="require-flag">*</span>
          </div>
          <textarea-editor
            class="item-text"
            v-model="richTextObj"
            :var-group="workflowVarGroupString"
            min-height="160"
            max-height="400"
          ></textarea-editor>
        </div>
        <!-- 审批、通知、查找内容 End -->

        <!-- 通知方式 -->
        <div v-if="setting.includes('notifyMethod')" class="contentItem">
          <div class="itemTitle">通知方式</div>
          <NormalSelect
            class="item-select"
            :selectList="notifyMethods"
            :multiple="true"
            :selectedItem.sync="selNotifyMethods"
          ></NormalSelect>
        </div>
        <!-- 通知方式 End -->

        <!-- 设置跳转记录 -->
        <div
          v-if="setting.includes('jumpSetting') && selNotifyMethods.toString() != 'ding'"
          class="contentItem"
        >
          <el-checkbox class="itemTitle" v-model="jumpChecked">设置跳转记录</el-checkbox>
          <tree-select
            v-if="jumpChecked && workFlowData.type != 'task'"
            :group-list="jumpMethods"
            v-model="selJumpMethods"
            style="margin-top: 10px"
          ></tree-select>
        </div>
        <!-- 设置跳转记录 End -->

        <!-- 选择钉钉群 -->
        <div v-if="setting.includes('selectGroup')" class="contentItem">
          <div class="itemTitle">通知群</div>
          <NormalSelect
            :selectList="groupMethods"
            :selectedItem.sync="selGroupMethods"
          ></NormalSelect>
        </div>
        <!-- 选择钉钉群 End -->

        <!-- 新增记录 -->
        <insert-sheet-data
          ref="insertSheetData"
          v-if="setting.includes('insertSheetData')"
          :extra="workFlowProcess.extra"
          :insert-data="workFlowProcess.data"
          :group-list="workflowVarGroup"
          :available-sheets="availableSheets"
        ></insert-sheet-data>
        <!-- 新增记录 End -->

        <!-- 数值运算 -->
        <set-num-compute
          ref="ServiceCompute"
          v-if="!requestLoading && setting.includes('setNumCompute')"
          :workflow-var-group="workflowVarGroup"
          :node-data="workFlowProcess.data"
          :extra="workFlowProcess.extra"
        ></set-num-compute>
        <!-- 数值运算 End -->

        <!-- 批量数据运算 -->
        <set-sheet-compute
          ref="ServiceCompute"
          v-if="setting.includes('setSheetCompute')"
          :workflow-var-group="workflowVarGroup"
          :available-sheets="availableSheets"
          :nodeData="workFlowProcess.data"
          :extra="workFlowProcess.extra"
        ></set-sheet-compute>
        <!-- 批量数据运算 End -->

        <!-- 日期运算 -->
        <SetDateCompute
          ref="ServiceCompute"
          v-if="setting.includes('setDateCompute')"
          :workflow-var-group="workflowVarGroup"
          :nodeInfo="workFlowProcess"
          :extra="workFlowProcess.extra"
        ></SetDateCompute>
        <!-- 日期运算 End -->

        <!-- 子流程 -->
        <SetSubProcess
          ref="SubProcess"
          v-if="setting.includes('setSubProcess')"
          :nodeInfo="workFlowProcess"
          :workflow-var-group="workflowVarGroup"
          :workflow-var-groups="workflowVarGroups"
          :work-flow-var-map="workFlowVarMap"
          :extra="workFlowProcess.extra"
          :app-id="appId"
        ></SetSubProcess>
        <!-- 子流程 End -->

        <!-- 短信通知 -->
        <SetPhone
          ref="phone"
          v-if="setting.includes('phone')"
          :nodeInfo="workFlowProcess"
          :extra="workFlowProcess.extra"
          :workFlowData="workFlowData"
          :workflow-var-group="workflowVarGroup"
          :flow-connected-data="flowConnectedData"
          :workflow-var-group-string="workflowVarGroupString"
        ></SetPhone>
        <!-- 短信通知 End -->

        <!-- email通知 -->
        <SetEmail
          ref="email"
          v-if="setting.includes('email')"
          :nodeInfo="workFlowProcess"
          :extra="workFlowProcess.extra"
          :workFlowData="workFlowData"
          :workflow-var-group="workflowVarGroup"
          :flow-connected-data="flowConnectedData"
          :emailData="emailData"
          :workflow-var-group-string="workflowVarGroupString"
        ></SetEmail>
        <!-- 邮件通知 End -->

        <!-- 校验 -->
        <set-validate
          ref="ServiceValidate"
          v-if="setting.includes('setServiceValidate')"
          :nodeInfo="workFlowProcess"
          :workflow-var-list="flowConnectedData"
          :workflow-var-group="workflowVarGroupString"
          :extra="workFlowProcess.extra"
          v-on="$listeners"
          :workflow-var-group-string-map="workflowVarGroupStringMap"
        ></set-validate>
        <!-- 校验 End -->

        <!-- 审批 -->
        <user-verify
          ref="UserVerify"
          v-if="setting.includes('userVerify')"
          :node-info="workFlowProcess"
          :flow-connected-data="flowConnectedData"
          :group-list="workflowVarGroup"
          :work-flow-data="workFlowData"
          :work-flow-control-map="workFlowControlMap"
          :available-sheets="availableSheets"
        ></user-verify>
        <!-- 审批 End -->

        <!-- 网络请求 -->
        <set-http-request
          ref="setHttpRequest"
          v-if="setting.includes('setHttpRequest')"
          :can2str-vars="workflowVarGroupString"
          :initial-node-info="workFlowProcess"
        ></set-http-request>
        <!-- 网络请求 End -->

        <!-- 代码块 -->
        <set-script
          ref="setScript"
          v-if="setting.includes('setScript')"
          :nodeInfo="workFlowProcess"
          :workflow-var-groups="workflowVarGroups"
        ></set-script>
        <!-- 代码块 End -->

        <!-- 锁定/解锁数据 -->
        <div v-if="setting.includes('lockData')" class="contentItem">
          <div class="itemTitle">
            锁定/解锁数据
            <el-tooltip effect="dark" content="数据锁定后将不可编辑" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <el-radio-group v-model="lock" style="margin-top: 16px" @change="changeExtra">
            <el-radio :label="true" border size="small" style="margin-right: 14px">
              锁定
            </el-radio>
            <el-radio :label="false" border size="small">解锁</el-radio>
          </el-radio-group>
        </div>
        <!-- 锁定/解锁数据 End -->

        <!-- 选择数据同步规则 -->
        <template v-if="setting.includes('selectRule')">
          <div class="contentItem">
            <div class="itemTitle">选择同步规则</div>
            <div class="titleTip" style="margin-bottom: 10px">当前应用中的同步规则</div>
            <normal-select
              size="normal"
              :selectList="dataSyncRuleList"
              :selectedItem.sync="selectedRuleId"
              default-label="规则不存在或已禁用"
              filterable
              @handle-select="selectedSheetData = ''"
              @update:selectedItem="changeExtra"
            ></normal-select>
          </div>
          <div class="contentItem">
            <div class="itemTitle">选择数据对象</div>
            <div class="titleTip" style="margin-bottom: 10px">当前流程中的数据对象</div>
            <tree-select
              :group-list="dataSyncRuleSelectableSheetDataList"
              v-model="selectedSheetData"
            ></tree-select>
          </div>
          <div class="contentItem" v-if="selectedDataSyncRule.master">
            <div class="itemTitle">选择同步目标</div>
            <div class="titleTip" style="margin-bottom: 10px">当前数据同步目标企业</div>
            <select-scope
              title="选择企业"
              :var-group="syncTargetCompanyGroup"
              multiple
              :show-user-tab="false"
              :show-department-tab="false"
              v-model="selectedSyncTarget"
              :additional-tabs="additionalTabs"
            ></select-scope>
          </div>
        </template>
        <!-- 选择数据同步规则 End -->

        <!-- http 触发 -->
        <http-trigger
          ref="httpTrigger"
          v-if="setting.includes('setHttpTrigger')"
          :workflow-id="workFlowId"
          :initial-node-info="workFlowProcess.trigger"
        ></http-trigger>

        <!-- 设置人员筛选条件 -->
        <set-search-user
          ref="setSearchUser"
          v-if="setting.includes('setSearchUser')"
          :extra="workFlowProcess.extra"
          :data="workFlowProcess.data"
          :group-list="flowConnectedData"
          :app-id="appId"
        ></set-search-user>

        <!-- 设置获取打印文件 -->
        <set-pdf
          ref="setPdf"
          v-if="setting.includes('setPdf')"
          :extra="workFlowProcess.extra"
          :data="workFlowProcess.data"
          :workflow-var-group="workflowVarGroup"
        ></set-pdf>
        <!--      数据来源-->
        <div class="contentItem" v-if="setting.includes('dataSources')">
          <div class="itemTitle">数据来源</div>
          <el-checkbox v-model="workFlowProcess.trigger.acceptBySync" style="margin-top:10px">
            允许企业互联数据触发
          </el-checkbox>
        </div>
        <!--      数据来源end-->
        <!-- 查找 -->
        <set-search
          ref="ServiceSearchMulti"
          v-if="setting.includes('setSearch')"
          :available-sheets="availableSheets"
          :extra="workFlowProcess.extra"
          :search-data="workFlowProcess.data"
          :flow-connected-data="flowConnectedData"
        ></set-search>
        <!-- 查找 End -->
      </div>
      <div class="btnContainer">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button plain @click="handleClose">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getAllSheet,
  getAvailableSheets,
  getGroupControls,
  getSimpleSheetList
} from "@/api/sheet/sheet"
import { getManageDashboardList } from "@/api/appManage/statistics"
import { getRoles } from "@/api/appManage/role"
import * as workflowApi from "@/api/workflow/workflow"
import {
  filterTreeVarGroup,
  getSettings,
  transOldExpr,
  transWorkflowVarGroup2TreeVarGroup
} from "@/utils/workFlow"
import SheetBg from "./components/sheetBg"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import InsertSheetData from "./components/insertSheetData"
import SelectScope from "@/components/UIComponents/SelectScope"
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import UpdateFields from "./components/updateFields"
import ExecuteTime from "./components/executeTime"
import TopTip from "./components/topTip"
import SetSheetCompute from "./components/setSheetCompute"
import SetDateCompute from "./components/setDateCompute"
import SetNumCompute from "./components/setNumCompute"
import SetSubProcess from "./components/setSubProcess"
import SetValidate from "./components/setValidate"
import SetHttpRequest from "./components/setHttpRequest/index"
import SetScript from "./components/setScript"
import SetPeople from "./components/SetPeople/SetPeople"
import DingGroup from "./components/dingGroup"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import Filters from "../../mixin/filters"
import { getFlowNodeData, notifyMethods } from "@/utils/workFlow"
import { EventBus } from "../../eventBus"
import { verifyCondition } from "@/utils/sheet"
import { getAllConnectedCompany, getCompanyConnectType, getOutSyncRuleList } from "@/api/connect"
import { bfs } from "@/utils/algorithm"
import UserVerify from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/UserVerify"
import HttpTrigger from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/HttpTrigger"
import SetPhone from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/setPhone"
import SetEmail from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/setEmail"
import SetSearchUser from "./components/SetSearchUser.vue"
import mixin from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/mixin"
import pairMixin from "./components/setHttpRequest/mixin"
import SetSearch from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SetSearch"
import SetPdf from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SetPdf"
import SetSeal from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SetSeal"
import OutputParams from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/OutputParams"
import { deepClone } from "@/utils/common"
import ScriptKeyValueParis from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/ScriptKeyValuePairs"

export default {
  name: "settingWorkflow",
  components: {
    ScriptKeyValueParis,
    OutputParams,
    SetSeal,
    SetPdf,
    SetSearch,
    SetPhone,
    SetEmail,
    HttpTrigger,
    UserVerify,
    SheetBg,
    NormalSelect,
    InsertSheetData,
    SelectScope,
    UpdateFields,
    ExecuteTime,
    SetNumCompute,
    SetSheetCompute,
    SetDateCompute,
    SetSubProcess,
    SetValidate,
    SetScript,
    SetHttpRequest,
    ConditionList,
    "top-tip": TopTip,
    SetPeople,
    DingGroup,
    TreeSelect,
    TextareaEditor,
    SetSearchUser
  },
  data() {
    return {
      notifyMethods, // 通知方式
      canFocus: false, // 仅用于解决open时，nameInput会自动被focus
      operateType: null, // 工作流触发方式[post]
      specifiedField: false, // 是否指定指定字段触发
      setting: [], // 当前工作流显示的组件的设置
      workFlowStyles: { nameIcon: "" }, // 当前工作流样式的设置
      allSheet: [], // 所有表格信息
      sheetInfo: {}, // 当前选择的表格信息
      selectedSheet: null, // 选择的表格Id[post]
      selectedFields: [], // 选择的表格字段Id(可以为多个)[post]
      filters: [],
      selectedField: null, // 选择的表格字段Id(1个)[post]
      selectedRole: null, // 选择的角色[post]
      requestLoading: true, // 请求当前工作流能使用的数据loading
      flowConnectedData: [], // 当前工作流能使用的数据
      selectPeopleBy: "people", // 按照人员或者角色选择人
      allRoles: [], // 所有角色
      selectedTarget: null, // 选择的节点对象
      updateFields: [], // 更新工作表
      richTextObj: {}, // 审批、通知、查找内容
      selectedPeople: [], // 选择的人员
      staffStructure: {}, // 选择的人员的组织结构关系
      isInitSelectedTarget: true, // 是否是初始化更新节点的选择对象
      verifyOriginator: [], // 审批发起人
      selectedTimeField: "", // 指定日期字段
      executeTime: {
        // 指定执行时间(按日期字段触发)
        field: "",
        controlType: "", // time,date
        operator: "equal", // equal, before, after
        number: "10",
        unit: "day", // minute, hour, day
        time: "08:00:00"
      },
      selNotifyMethods: [], // 选择的通知方式
      cronStr: "", // cron表达式
      delayStr: "", // 延时表达式
      lock: true, // 锁定或解锁数据
      isAdd: true, // 添加/移除 参与人
      availableSheets: [], // 可用的工作表
      loadingRoles: true, // 加载角色
      dataSyncRuleList: [], // 数据同步规则列表
      selectedRuleId: null, // 选中的规则ID
      selectedSheetData: null, // 选中的工作表数据
      selectedSyncTarget: [], // 选中的同步对象
      connectedCompanies: [], // 互联企业列表
      connectedTypes: [], // 互联角色列表
      dataSource: "",
      subParams: {},
      workFlows: [],
      sheetList: [],
      jumpChecked: false, // 是否选择跳转记录
      jumpMethods: [], // 允许跳转列表
      selJumpMethods: "", // 跳转选择对象
      groupMethods: [], // 钉钉群选择列表
      selGroupMethods: "", // 钉钉群选择对象
      selectedVar: "",
      sheetId: "",
      dingGroupData: {},
      emailData: {},
      limitType: "NONE",
      waitSecond: "",
      radioDisable: false,
      limitCids: [],
      boardList: [], // 当前应用的看板
      extraInput: [],
      controls: [],
      expresion: ""
    }
  },
  props: {
    drawerVisible: Boolean,
    workFlowId: String,
    workFlowData: Object,
    workFlowProcess: Object,
    triggerSheetId: String,
    controlTypeMap: Object
  },
  mixins: [Filters, mixin, pairMixin],
  computed: {
    appNameMap() {
      let result = {}
      this.availableSheets.forEach(app => (result[app.id] = app.name))
      return result
    },
    workflowVarGroups() {
      let sheetList = deepClone(this.availableSheets)
      let apps = sheetList.map(app => {
        app.vars = []
        app.name = "系统变量_" + this.appNameMap[app.id]
        app.groups = app.sheets.map(sheet => {
          sheet.name = "系统变量_" + this.appNameMap[app.id] + "_" + sheet.name
          sheet.groups = []
          let sheetInfo = {
            name: "工作表ID",
            expresion: sheet.sheetId,
            expresionStr: sheet.sheetId,
            control: {
              _type: "text"
            }
          }
          sheet.vars = [sheetInfo].concat(
            sheet.controls.map(control => {
              control.control = control
              control.expresion = control._cid
              control.expresionStr = control._cid
              return control
            })
          )
          return sheet
        })
        return app
      })
      let sheets = [{ name: "系统变量", vars: [], groups: apps }]
      let dealSheets = transWorkflowVarGroup2TreeVarGroup(sheets, this.controlTypeMap) || []
      return dealSheets.concat(this.workflowVarGroup)
    },
    controlMap() {
      return this._.keyBy(this.controls, "_type")
    },
    workFlowJumpMap() {
      let map = {}
      bfs({
        arr: this.jumpMethods,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(
            option =>
              (map[option.value] = {
                expresion: option.value
              })
          )
        }
      })
      return map
    },
    workFlowVarMap() {
      let map = {}
      bfs({
        arr: this.workflowVarGroups,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(
            option =>
              (map[option.value] = {
                expresion: option.value,
                expresionStr: option.strValue,
                control: option.control
              })
          )
        }
      })
      return map
    },
    peopleLabel() {
      let peopleLabel = ""
      switch (this.workFlowProcess.type) {
        case "UserVerify": {
          peopleLabel = "审批人员"
          break
        }
        case "UserFillSheet": {
          peopleLabel = "填写人员"
          break
        }
        case "ServiceNotify": {
          peopleLabel = "通知人员"
          break
        }
      }
      return peopleLabel
    },
    selectedDataSyncRule() {
      return this.dataSyncRuleList?.find(r => r.id === this.selectedRuleId) || {}
    },
    dataSyncRuleSelectableSheetDataList() {
      // 根据当前选择的数据同步规则,筛选可选择的工作流变量
      let selectedRule = this.selectedDataSyncRule
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) => {
          return (
            control._type === "ref" &&
            control?.refSheetId &&
            (this._.isEmpty(selectedRule) || control.refSheetId === selectedRule.sheetId)
          )
        }
      })
    },
    syncTargetCompanyGroup() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) => control._type === "company"
      })
    },
    additionalTabs() {
      return [
        {
          label: "企业",
          value: "company",
          options: this.connectedCompanies.map(({ id, name }) => ({ id, name }))
        },
        {
          label: "企业角色",
          value: "companyRole",
          options: this.connectedTypes.map(({ id, name }) => ({ id, name }))
        }
      ]
    },
    workflowVarGroup() {
      return transWorkflowVarGroup2TreeVarGroup(this.flowConnectedData, this.controlTypeMap)
    },
    workflowVarGroupControlTypeRef() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: option => option.control?._type === "ref" && option.control?.refSheetId
      })
    },
    workflowVarGroupString() {
      return filterTreeVarGroup({
        varGroup: this._.cloneDeep(this.workflowVarGroup),
        filterFunc: ({ strValue }) => strValue,
        mapFunc: option => Object.assign({}, option, { value: option.strValue })
      })
    },
    workflowVarGroupStringMap() {
      let map = {}
      bfs({
        arr: this.workflowVarGroupString,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.label))
        }
      })
      return map
    },
    workFlowControlMap() {
      let map = {}
      bfs({
        arr: this.workflowVarGroupControlTypeRef,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.control))
        }
      })
      return map
    },
    workFlowInfo() {
      let map = {}
      bfs({
        arr: this.workflowVarGroupControlTypeRef,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.label))
        }
      })
      return map
    },
    searchSheetMap() {
      let map = {}
      this.availableSheets.forEach(item => {
        item.sheets.forEach(sheet => (map[sheet.sheetId] = sheet.name))
      })
      return map
    },
    workFlowValueLabelMap() {
      let map = {}
      bfs({
        arr: this.workflowVarGroup,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.label))
        }
      })
      return map
    },
    appId() {
      return this.workFlowData.appId
    }
  },
  watch: {
    selectedSheet: function(newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.sheetInfo = this.allSheet.find(i => i.sheetId == newVal) || {}
        this.selectedTimeField = null
        this.selectedFields = []
        this.filters = []
      }
    }
  },
  methods: {
    getSheetInfo() {
      if (this.workFlowData.type === "task") return Promise.resolve()
      return Promise.all([
        getSimpleSheetList(this.appId).then(sheetList => {
          this.sheetList = sheetList.map(sheet => ({
            label: sheet.name,
            value: sheet.sheetId
          }))
        }),
        getAvailableSheets({ appId: this.appId }).then(res => {
          this.availableSheets = res
        })
      ])
    },
    getControls() {
      return getGroupControls().then(res => {
        let result = []
        res.forEach(group => {
          result = result.concat(group.options)
        })
        this.controls = result
      })
    },
    open() {
      this.requestLoading = true
      Promise.all([
        this.getSheetInfo(),
        getAllConnectedCompany().then(companies => (this.connectedCompanies = companies)),
        getCompanyConnectType({ withNum: false }).then(types => (this.connectedTypes = types)),
        this.getFlowConnectedData(),
        this.getControls()
      ]).then(() => {
        let { setting, style } = getSettings(this.workFlowProcess, this.workFlowData.type)
        this.setting = setting
        this.workFlowStyles = style
        // 等待组件挂载
        this.$nextTick(() => {
          if (this.workFlowData.type == "task") this.initDataForTask()
          else this.initData()
        })
      })
    },
    opened() {
      // 仅用于解决open时，nameInput会自动被focus
      this.canFocus = true
      this.$refs.nameInput.blur()
    },
    handleClose() {
      this.$emit("update:drawerVisible", false)
    },
    closed() {
      Object.assign(this.$data, this.$options.data())
    },
    beforeSubmit() {
      switch (this.workFlowProcess.type) {
        case "ServiceNumCompute":
          return this.$refs.ServiceCompute.submit().then(
            nodeData => (this.workFlowProcess.data = nodeData)
          )
      }
      return new Promise((resolve, reject) => {
        // 触发节点
        switch (this.workFlowProcess.type) {
          case "workFlowStart":
            if (this.workFlowProcess.trigger.type === "START_TYPE_DATA") {
              if (!this.selectedSheet) return reject("未选择工作表")
            } else if (this.workFlowProcess.trigger.type === "START_TYPE_CRON") {
              if (!this.cronStr) return reject("未输入cron表达式")
              let reg = /([\u4E00-\u9FA5]|[\uFE30-\uFFA0])+/
              if (reg.test(this.cronStr)) {
                return reject("延时表达式不允许输入中文符号")
              }
            } else if (this.workFlowProcess.trigger.type === "START_TYPE_TIME") {
              if (!this.selectedSheet) return reject("未选择工作表")
              if (!this.selectedTimeField) return reject("未选择指定日期字段")
              if (!this._.isEmpty(this.executeTime)) {
                let str = "执行时间未填写完整"
                if (!this.executeTime.operator) {
                  return reject(str)
                }
                if (
                  this.executeTime.operator !== "equal" &&
                  (!this.executeTime.number.toString() || !this.executeTime.unit)
                ) {
                  return reject(str)
                }
              }
            } else if (this.workFlowProcess.trigger.type === "START_TYPE_HTTP") {
              let data = this.$refs.httpTrigger.output()
              if (!data) return reject(false)
              this.workFlowProcess.trigger = data
              this.workFlowProcess.trigger.extra = { description: { state: "已配置" } }
            } else if (this.workFlowProcess.trigger.type === "START_TYPE_SUB") {
              if (!this.workFlowProcess.trigger.control.refSheetId) {
                if (!this.$refs.subParam.validate()) return
                this.workFlowProcess.trigger.control = this.$refs.subParam.getValue()
              }
              if (!this.verifyPairs(this.extraInput, "submit", " 定义Input对象 ")) return
              this.$set(
                this.workFlowProcess.trigger,
                "extraInput",
                this.extraInput.map(item => {
                  return Object.assign(
                    {},
                    { control: this.controlMap[item.value.value] },
                    {
                      name: item.key
                    }
                  )
                })
              )
            }
            break
          case "ServiceSearchMulti": {
            let ref = this.$refs.ServiceSearchMulti
            this.workFlowProcess.data.sorts = [ref.$data.sort]
            let { result, msg } = verifyCondition("submit", this.workFlowProcess.data.condition)
            if (!result) {
              return reject(msg)
            }
            if (!this.workFlowProcess.data.sheetId) return reject("未选择工作表")
            break
          }
          case "ServicePdf": {
            if (!this.workFlowProcess.data.dataId) {
              return reject("请选择打印数据")
            }
            if (!this.workFlowProcess.data.templateId) {
              return reject("请选择打印模板")
            }
            break
          }
          case "UserSeal": {
            if (!this.workFlowProcess.data.startUserInfo.name) {
              return reject("请选择发起人")
            }
            if (this._.isEmpty(this.workFlowProcess.data.signParams)) {
              return reject("请选择签署人")
            }
            if (!this.workFlowProcess.data.attachmentId) {
              return reject("请选择签署文件")
            }
            break
          }
          case "ServiceSheetCompute": {
            let ref = this.$refs.ServiceCompute
            this.workFlowProcess.data = ref.$data.tempNodeData
            if (!this.workFlowProcess.data.varName) {
              return reject("请选择运算对象")
            }
            if (!this.workFlowProcess.data.cid) {
              return reject("请选择运算字段")
            }
            if (!this.workFlowProcess.data.method) {
              return reject("请选择运算方法")
            }
            break
          }
          case "ServiceDateCompute": {
            let ref = this.$refs.ServiceCompute
            this.workFlowProcess.data = ref.$data.tempNodeInfo.data
            let value = this.workFlowProcess.data.value
            for (let i in value) {
              if (!value[i] || value[i] == "") value[i] = 0
            }
            if (!this.workFlowProcess.data.start) {
              return reject("请选择运算日期/时间")
            }
            if (!this.workFlowProcess.data.format) {
              return reject("请选择运算时的日期格式")
            }
            break
          }
          case "SubProcess": {
            let ref = this.$refs.SubProcess
            this.workFlowProcess.data = ref.$data.tempNodeData
            let extraInputs = ref.$data.inputs
            if (!this.workFlowProcess.data.var) return reject("数据对象不能为空")
            if (!this.verifyPairs(extraInputs, "submit", " 传入变量 ")) return
            this.$set(
              this.workFlowProcess.data,
              "extraInput",
              extraInputs.map(item => {
                return Object.assign({}, this.workFlowVarMap[item.value.value], { name: item.key })
              })
            )
            if (!this.workFlowProcess.data.subProcessId) return reject("子流程不能为空")
            if (this.workFlowProcess.data.output) {
              if (!ref.$refs.outputParams.validate()) return
              this.$set(this.workFlowProcess.data, "output", ref.$refs.outputParams.getValue())
            }
            break
          }
          case "ServiceValidate": {
            let ref = this.$refs.ServiceValidate
            this.workFlowProcess.data = ref.$data.tempNodeData
            if (this._.isEmpty(this.workFlowProcess.data.items)) return reject("校验规则不能为空")
            break
          }
          case "ServiceHttp": {
            let data = this.$refs.setHttpRequest.output()
            if (!data) return reject(false)
            this.workFlowProcess.data = data
            this.workFlowProcess.extra.description = { state: "已配置" }
            break
          }
          case "ServiceScript": {
            let data = this.$refs.setScript.output()
            if (!data) return reject(false)
            this.workFlowProcess.data = data
            this.workFlowProcess.extra.description = { state: "已配置" }
            break
          }
          case "UserVerify": {
            let ref = this.$refs.UserVerify
            this.workFlowProcess.data = ref.$data.tempNodeData
            // 审批意见
            let data = this.$refs.UserVerify.$refs.verifyItems.output()
            if (!data) return reject(false)
            this.workFlowProcess.data.verifyItems = data
            if (this.workFlowData.type == "task") {
              let { result, msg } = this.$refs.UserVerify.$refs.TaskVerify.output()
              if (!result) return reject(msg)
            } else {
              if (!ref.tempNodeData.dataVar) reject("未选择审批对象")
              // 审批按钮名称
              if (!ref.tempNodeData.acceptButtonName || !ref.tempNodeData.rejectButtonName)
                reject("按钮名称必填")
              // 审批内容
              if (this.$refs.UserVerify.$refs.verifyContent) {
                if (!this.workFlowProcess.data.verifyContents.length) {
                  reject("审批内容必填")
                }
              }
              // 审批发起人，审批人员
              let { result, msg } = this.$refs.UserVerify.$refs.SheetVerify.output()
              if (!result) return reject(msg)
            }
            // 消息通知
            if (!ref.$data.richTextObj.text) {
              reject("请填写消息通知")
            }
            this.workFlowProcess.data.content = ref.$data.richTextObj.text
            this.workFlowProcess.extra.textarea = ref.$data.richTextObj.arr
            break
          }
          case "ServiceNotify":
            if (this.setting.includes("phone")) {
              let ref = this.$refs.phone
              let { result, msg } = ref.beforeOutput()
              if (!result) return reject(msg)
              ref.getParams()
              this.workFlowProcess.data.phoneMessage = ref.$data.tempNodeData
              this.workFlowProcess.extra.notifyMethod = "短信通知"
              this.workFlowProcess.extra.candidates = this.getCandidates(
                this.workFlowProcess.extra.candidates,
                ref.$data.tempNodeData
              )
            } else if (this.setting.includes("email")) {
              let ref = this.$refs.email
              let { result, msg } = ref.beforeOutput()
              this.emailData = {
                subjectObj: {
                  text: ref.$data.subjectObj.text,
                  arr: ref.$data.subjectObj.arr
                },
                contentObj: {
                  text: ref.$data.contentObj.text,
                  arr: ref.$data.contentObj.arr
                },
                fileList: ref.$data.fileList,
                emailDefs: ref.$data.emailDefs,
                emails: ref.$data.emails,
                emailDefsExtra: ref.$data.emailDefsExtra
              }
              this.workFlowProcess.extra.notifyMethod = "邮件通知"
              if (!result) return reject(msg)
            } else if (!this.setting.includes("dingGroup")) {
              let { result, msg } = this.$refs.SetPeople.output()
              let content = this.workFlowJumpMap[this.selJumpMethods]
              if (this.jumpChecked && !this.selJumpMethods && this.workFlowData.type != "task")
                return reject("未设置跳转记录")
              if (!content && this.jumpChecked) return reject("无效跳转记录")
              if (!result) return reject(msg)
            } else {
              let { result, msg } = this.$refs.dingGroup.output()
              if (!result) return reject(msg)
            }
            break
          case "ServiceDataSync":
            if (!this.selectedRuleId) return reject("同步规则不能为空")
            if (!this.selectedSheetData) return reject("同步数据不能为空")
            if (this.selectedDataSyncRule.master && !this.selectedSyncTarget.length)
              return reject("同步目标不能为空")
            this.workFlowProcess.data.isMaster = this.selectedDataSyncRule.master
            break
          case "ServiceInsertSheet":
            this.$refs.insertSheetData
              .validate()
              .then(() => resolve())
              .catch(() => reject("新增记录节点设置项校验失败"))
            return
          case "ServiceDeleteSheet":
            if (!this.selectedVar) return reject("未选择数据对象")
            break
          case "TimerDelay":
            if (!this.delayStr) return reject("未输入延时表达式")
            // eslint-disable-next-line no-case-declarations
            let reg = /([\u4E00-\u9FA5]|[\uFE30-\uFFA0])+/
            if (reg.test(this.delayStr)) {
              return reject("延时表达式不允许输入中文符号")
            }
            break
          case "SubProcessRes":
            if (!this.expresion) return reject("未选择输出参数")
            this.workFlowProcess.data.expresion = this.expresion
            break
          case "ServiceSetPart":
            if (!this.selectedTarget) return reject("未选择节点对象")
            if (this._.isEmpty(this.selectedPeople)) return reject("未选择参与人")
            break
          case "ServiceLock":
            if (!this.selectedTarget) return reject("未选择节点对象")
            break
        }
        resolve()
      })
    },
    getCandidates(person, data) {
      let tel = ""
      data.telephones?.forEach(telephone => {
        tel = tel + this.workFlowValueLabelMap[telephone] + "，"
      })
      let result = person ? person + "，" + tel : tel
      return result.slice(0, result.length - 1)
    },
    async submit({ refreshFlowConnectedData = false } = {}) {
      try {
        await this.beforeSubmit()
        let outputData = getFlowNodeData(
          this.$data,
          this.workFlowProcess,
          this.workFlowData,
          this.setting
        )
        Object.assign(this.workFlowProcess, outputData)
        EventBus.$emit("updateFlowNode", {
          nodeInfo: outputData,
          refreshFlowConnectedData
        })
      } catch (err) {
        console.error("节点校验错误", err)
        this.$notify.error({
          title: "修改错误",
          message: err
        })
        // 如果有表单校验项失败,则自动滚动到失败位置
        this.scrollToFormValidateErr()
      }
    },
    scrollToFormValidateErr() {
      setTimeout(() =>
        this.$refs.scrollWrapper.querySelector(".el-form-item.is-error")?.scrollIntoView()
      )
    },
    async initData() {
      switch (this.workFlowProcess.type) {
        // 初始化开始结点的信息
        case "workFlowStart": {
          // 定时触发
          if (this.workFlowProcess.trigger.type === "START_TYPE_CRON") {
            this.cronStr = this.workFlowProcess.trigger.cronStr
            break
          }
          if (this.workFlowProcess.trigger.type === "START_TYPE_SUB") {
            this.subParams = this.workFlowProcess.trigger.control
            this.workFlowProcess.trigger.extraInput?.forEach(input => {
              this.extraInput.push({
                key: input.name,
                value: {
                  inFlow: false,
                  label: input.control._type,
                  value: input.control._type
                }
              })
            })
            if (this.workFlowProcess.trigger.control._type === "ref") {
              this.dataSource = this.searchSheetMap?.[
                this.workFlowProcess.trigger.control.refSheetId
              ]
            } else {
              this.dataSource = this.controlTypeMap?.[
                this.workFlowProcess.trigger.control._type
              ]?.name
            }
            this.workFlows = await workflowApi.getMainProcess(this.workFlowProcess.id)
            break
          }
          this.allSheet = await getAllSheet(this.appId)
          this.selectedSheet = this.workFlowProcess.trigger.sheetId
          // 工作表新增、插入
          if (["C", "U", "CU"].includes(this.workFlowProcess.trigger.operateType)) {
            this.operateType = this.workFlowProcess.trigger.operateType
            if (
              this.workFlowProcess.trigger.fields &&
              this.workFlowProcess.trigger.fields.length > 0
            ) {
              this.specifiedField = true
              this.$nextTick(() => {
                this.selectedFields = this.workFlowProcess.trigger.fields
              })
            }
            if (
              this.workFlowProcess.trigger.filters &&
              this.workFlowProcess.trigger.filters.length > 0
            ) {
              this.$nextTick(() => {
                this.filters = this.workFlowProcess.trigger.filters
              })
            }
          }
          // 日期字段触发
          else if (this.workFlowProcess.trigger.type === "START_TYPE_TIME") {
            this.$nextTick(() => {
              this.selectedTimeField = this.workFlowProcess.trigger.field
            })
            if (
              this.workFlowProcess.trigger.filters &&
              this.workFlowProcess.trigger.filters.length > 0
            ) {
              this.$nextTick(() => {
                this.filters = this.workFlowProcess.trigger.filters
              })
            }
            Object.assign(this.executeTime, this.workFlowProcess.trigger)
          } else if (this.workFlowProcess.trigger.type === "START_TYPE_VALIDATE") {
            if (
              this.workFlowProcess.trigger.filters &&
              this.workFlowProcess.trigger.filters.length > 0
            ) {
              this.$nextTick(() => {
                this.filters = this.workFlowProcess.trigger.filters
              })
            }
          }
          if (["START_TYPE_DATA", "START_TYPE_BTN"].includes(this.workFlowProcess.trigger.type)) {
            this.limitType = this.workFlowProcess.trigger.parallelSetting.limitType
            this.waitSecond = this.workFlowProcess.trigger.parallelSetting.waitSecond
            this.limitCids = this.workFlowProcess.trigger.parallelSetting.limitCids
          }
          break
        }
        // 初始化延时节点
        case "TimerDelay":
          this.delayStr = this.workFlowProcess.data.expression
          break
        // 初始化子流程出参节点
        case "SubProcessRes":
          this.expresion = this.workFlowProcess.data.expresion
          break
        // 初始化同步节点
        case "ServiceDataSync": {
          let dataSyncRuleList = await getOutSyncRuleList(this.appId)
          this.dataSyncRuleList = dataSyncRuleList.map(r => {
            r.value = r.id
            r.label = r.name
            return r
          })
          this.selectedRuleId = this.workFlowProcess.data.ruleId
          this.selectedSheetData = transOldExpr(this.workFlowProcess.data.dataExpression)
          this.selectedSyncTarget = this.transOldObjArr(this.workFlowProcess.data.targets)
          break
        }
        // 初始化更新工作表的更新字段信息
        case "ServiceUpdateSheet":
          this.updateFields = []
          for (let key of Object.keys(this.workFlowProcess.data.updateInfo)) {
            this.updateFields.push({
              key,
              type: this.workFlowProcess.data.updateInfo[key].type,
              value: this.workFlowProcess.data.updateInfo[key].value
            })
          }
          this.$refs.updateFields.initialData(this.updateFields.length != 0)
          break
        // 初始化删除节点的配置信息
        case "ServiceDeleteSheet":
          this.selectedVar = transOldExpr(this.workFlowProcess.data.var)
          this.sheetId = this.workFlowControlMap?.[this.selectedVar]?.refSheetId
          break
        // 初始化用户审批节点信息
        case "UserVerify":
          this.$nextTick(() => this.$refs.UserVerify.init())
          this.$nextTick(() => this.$refs.UserVerify.$refs.SheetVerify.init())
          break
        // 初始化批量获取数据节点信息
        case "ServiceSearchMulti": {
          this.availableSheets = await getAvailableSheets({ appId: this.appId })
          break
        }
        // 初始化锁定/解锁节点信息
        case "ServiceLock": {
          this.initSelectTarget()
          this.lock = this.workFlowProcess.data.lock
          break
        }
        // 初始化设置参与人节点信息
        case "ServiceSetPart": {
          this.initSelectTarget()
          this.initialSelectPeople()
          this.isAdd = this.workFlowProcess.data.add ? true : false
          break
        }
        // 初始化通知
        case "ServiceNotify": {
          if (this.workFlowProcess.data.type.includes("phone")) {
            // 初始化短信通知
            this.$refs.phone.init()
          } else if (this.workFlowProcess.data.type.includes("emailFile")) {
            // 初始化邮件通知
            this.emailData = {
              subjectObj: {
                text: this.workFlowProcess?.data?.mailMessage?.subject,
                arr: this.workFlowProcess?.extra?.emailSubject
              },
              contentObj: {
                text: this.workFlowProcess?.data?.mailMessage?.content,
                arr: this.workFlowProcess?.extra?.emailContent
              },
              fileList: this.workFlowProcess?.data?.mailMessage?.fileList,
              emailDefs: [].concat(this.workFlowProcess?.data?.mailMessage?.emailDefs || []),
              emails: this.workFlowProcess?.data?.mailMessage?.emails,
              emailDefsExtra: [].concat(this.workFlowProcess?.extra?.emailDefsExtra || [])
            }
            this.$refs.email.init()
          } else if (this.workFlowProcess.data.type.includes("dingGroup")) {
            // 初始化群通知
            this.dingGroupData = {
              richTextObj: {
                text: this.workFlowProcess.data.baseMessage?.content,
                arr: this.workFlowProcess.extra?.textarea
              },
              selGroupMethods: this.workFlowProcess.data?.dingGroupId
            }
            this.$refs.dingGroup.init()
          } else {
            // 初始化站内/钉钉通知
            this.$nextTick(() => this.$refs.SetPeople.init())
            this.initialInputTextarea()
            this.selNotifyMethods = this.workFlowProcess.data.type
            await this.initJumpSetting()
          }
          break
        }
      }
      // 关闭 loading
      this.requestLoading = false
    },
    initSelectTarget() {
      if (["ServiceLock", "ServiceSetPart"].includes(this.workFlowProcess.type)) {
        this.selectedTarget = transOldExpr(this.workFlowProcess.data.dataId)
        this.sheetId = this.workFlowControlMap?.[this.selectedTarget]?.refSheetId
      } else {
        this.selectedTarget = transOldExpr(this.workFlowProcess.data.sheetDataId)
      }
      this.$nextTick(() => {
        this.isInitSelectedTarget = false
      })
    },
    // 初始化跳转记录
    async initJumpSetting() {
      let singleRefList = filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) => control?._type === "ref" && control?.oneFlag,
        mapFunc: option => ({
          label: option.label,
          value: option.value,
          sheetId: option.control.refSheetId,
          type: "data"
        })
      })
      await this.getBoardList()
      let boardList_f = {
        label: "看板",
        options: this.boardList
      }
      this.jumpMethods = singleRefList.concat(boardList_f)
      if (this.workFlowProcess.extra?.dataId) {
        this.jumpChecked = true
        this.selJumpMethods = transOldExpr(this.workFlowProcess.extra.dataId)
      }
    },
    getBoardList() {
      return getManageDashboardList(this.appId).then(
        res =>
          (this.boardList = res.map(board => ({
            value: board.id,
            appId: board.appId,
            label: "[看板] " + board.name,
            type: "dashboard"
          })))
      )
    },
    async initDataForTask() {
      switch (this.workFlowProcess.type) {
        case "UserVerify": {
          this.$nextTick(() => this.$refs.UserVerify.init())
          this.$nextTick(() => this.$refs.UserVerify.$refs.TaskVerify.init())
          break
        }
        case "ServiceNotify": {
          if (this.workFlowProcess.data.type[0] == "dingGroup") {
            this.dingGroupData = {
              richTextObj: {
                text: this.workFlowProcess.data.baseMessage?.content,
                arr: this.workFlowProcess.extra?.textarea
              },
              selGroupMethods: this.workFlowProcess.data?.dingGroupId
            }
            this.$refs.dingGroup.init()
          } else if (this.workFlowProcess.data.type[0] === "email") {
            this.emailData = {
              subjectObj: {
                text: this.workFlowProcess?.data?.mailMessage?.subject,
                arr: this.workFlowProcess?.extra?.emailSubject
              },
              contentObj: {
                text: this.workFlowProcess?.data?.mailMessage?.content,
                arr: this.workFlowProcess?.extra?.emailContent
              },
              fileList: this.workFlowProcess?.data?.mailMessage?.fileList,
              emailDefs: [].concat(this.workFlowProcess?.data?.mailMessage?.emailDefs || []),
              emails: this.workFlowProcess?.data?.mailMessage?.emails,
              emailDefsExtra: [].concat(this.workFlowProcess?.extra?.emailDefsExtra || [])
            }
            this.$refs.email.init()
          } else {
            this.selNotifyMethods = this.workFlowProcess.data.type
            if (this.workFlowProcess.extra?.dataId) this.jumpChecked = true
            this.initialInputTextarea()
            this.$nextTick(() => this.$refs.SetPeople.init())
          }
          break
        }
      }
      this.requestLoading = false
    },
    getRoles() {
      this.selectPeopleBy = "role"
      return getRoles({ appId: this.appId, cache: false }).then(data => {
        this.loadingRoles = false
        this.allRoles = data
      })
    },
    initialSelectPeople() {
      if (this.workFlowProcess.data.userType == "role") {
        this.selectPeopleBy = "role"
        let selectedRole = ""
        if (this.workFlowProcess.type == "ServiceNotify")
          selectedRole = this.workFlowProcess.data.targets[0]
        else selectedRole = this.workFlowProcess.data.candidateUsers[0]
        this.getRoles().then(() => {
          this.loadingRoles = false
          this.selectedRole = selectedRole
        })
      } else if (this.workFlowProcess.data.userType == "superior") {
        this.selectPeopleBy = "people"
        this.staffStructure = { label: "上级", value: "superior" }
        this.selectedPeople = this.transOldObjArr(this.workFlowProcess.extra?.selectedPeople)
      } else {
        this.selectPeopleBy = "people"
        this.selectedPeople = this.transOldObjArr(this.workFlowProcess.extra?.selectedPeople)
      }
    },
    initialSelectPerson() {
      this.verifyOriginator =
        this.workFlowProcess.extra && this.workFlowProcess.extra.verifyOriginator
          ? this.workFlowProcess.extra.verifyOriginator
          : []
      this.$nextTick(() => {
        this.$refs.selectPerson.initialData(this.verifyOriginator)
      })
    },
    initialInputTextarea() {
      if (this.workFlowProcess.extra && this.workFlowProcess.extra.textarea) {
        // 通知，审批内容
        if (["UserVerify"].includes(this.workFlowProcess.type)) {
          this.richTextObj = {
            text: this.workFlowProcess.data.content,
            arr: this.workFlowProcess.extra.textarea
          }
        } else if (this.workFlowProcess.type == "ServiceNotify") {
          this.richTextObj = {
            text: this.workFlowProcess.data.baseMessage.content,
            arr: this.workFlowProcess.extra.textarea
          }
        }
      }
    },
    selectTimeField(item) {
      this.executeTime.field = item.value
      this.executeTime.controlType = item.type
    },
    // 新建的更新工作表节点需要刷新 flowConnectedData
    getFlowConnectedData() {
      if (this.workFlowProcess.type === "workFlowStart") {
        this.flowConnectedData = []
        return Promise.resolve()
      }
      return workflowApi
        .getWorkflowVars(this.workFlowId, this.workFlowProcess.id)
        .then(flowConnectedData => (this.flowConnectedData = flowConnectedData))
    },
    editMainWorkFlow(id) {
      const { href } = this.$router.resolve({
        name: "admin-edit-workflow",
        query: { id: id }
      })
      window.open(href, "_blank")
    },
    changeState(val) {
      this.radioDisable = val
    },
    changeExtra() {
      switch (this.workFlowProcess.type) {
        case "TimerDelay":
          this.$set(this.workFlowProcess.extra, "description", {
            expression: this.delayStr
          })
          break
        case "SubProcessRes":
          this.$set(this.workFlowProcess.extra, "description", {
            expression: this.workFlowValueLabelMap[this.expresion]
          })
          break
        case "ServiceDeleteSheet":
          if (this.selectedVar) {
            this.sheetId = this.workFlowControlMap?.[this.selectedVar]?.refSheetId
            let sheetName = this.sheetList?.find(sheet => sheet.value === this.sheetId).label
            let deleteVar = this.workFlowInfo?.[this.selectedVar]
            this.$set(this.workFlowProcess.extra, "description", {
              sheetName: sheetName,
              deleteVar: deleteVar
            })
          }
          break
        case "ServiceSetPart":
        case "ServiceLock":
          if (this.selectedTarget) {
            this.sheetId = this.workFlowControlMap?.[this.selectedTarget]?.refSheetId
            let sheetName = this.sheetList?.find(sheet => sheet.value === this.sheetId).label
            let target = this.workFlowInfo?.[this.selectedTarget]
            this.$set(this.workFlowProcess.extra, "description", {
              sheetName: sheetName,
              target: target,
              operation:
                this.workFlowProcess.type === "ServiceSetPart"
                  ? this.isAdd
                    ? "添加参与人"
                    : "移除参与人"
                  : this.lock
                  ? "锁定数据"
                  : "解锁数据"
            })
          }
          break
        case "ServiceDataSync":
          this.$set(this.workFlowProcess.extra, "description", {
            syncRule: this.dataSyncRuleList?.find(
              dataSyncRule => dataSyncRule.id === this.selectedRuleId
            ).name
          })
          break
      }
    },
    // 将收集来的关于触发方式数据传入接口中
    getDataTriggerExtra() {
      if (this.selectedSheet && this.operateType) {
        let sheetName = this.allSheet?.find(sheet => sheet.sheetId === this.selectedSheet).name
        let extra = this.workFlowProcess.trigger.extra || {}
        extra.description = {
          sheetName: sheetName,
          operation:
            this.operateType === "CU"
              ? "当新增或更新记录时触发"
              : this.operateType === "C"
              ? "当新增记录时触发"
              : "当更新记录时触发"
        }
        this.$set(this.workFlowProcess.trigger, "extra", extra)
      }
    },
    changeTriggerExtra() {
      switch (this.workFlowProcess.trigger.type) {
        case "START_TYPE_DATA":
          this.getDataTriggerExtra()
          break
        case "START_TYPE_CRON":
          if (this.cronStr) {
            let extra = this.workFlowProcess.trigger.extra || {}
            extra.description = {
              expression: this.cronStr
            }
            this.$set(this.workFlowProcess.trigger, "extra", extra)
          }
          break
        case "START_TYPE_TIME":
          if (this.selectedSheet && this.selectedTimeField) {
            let sheetName = this.allSheet?.find(sheet => sheet.sheetId === this.selectedSheet).name
            let timeFieldName =
              this.selectedTimeField === "cat"
                ? "[日期时间] 创建时间"
                : this.selectedTimeField === "uat"
                ? "[日期时间] 更新时间"
                : this.sheetInfo?.controls?.find(control => control._cid === this.selectedTimeField)
                    .name
            let time =
              this.executeTime.operator === "equal"
                ? "指定的日期时间"
                : (this.executeTime.operator === "before" ? "之前" : "之后") +
                  this.executeTime.number +
                  (this.executeTime.unit === "minute"
                    ? "分钟"
                    : this.executeTime.unit === "hour"
                    ? "小时"
                    : "天")
            let extra = this.workFlowProcess.trigger.extra || {}
            extra.description = {
              sheetName: sheetName,
              time: timeFieldName + " " + time + "执行"
            }
            this.$set(this.workFlowProcess.trigger, "extra", extra)
          }
          break
      }
    },
    changeOperateType() {
      this.specifiedField = false
      this.selectedFields = []
      this.getDataTriggerExtra()
    },
    changeLimitType(val) {
      this.limitType = val ? "NONE" : null
      this.limitCids = []
      this.waitSecond = this.workFlowProcess.trigger.type === "START_TYPE_DATA" ? 60 : 2
    }
  }
}
</script>

<style lang="scss">
.setting-workFlow {
  width: 480px;
  &:focus {
    outline: none;
  }
  .el-input {
    .el-input__inner {
      height: 40px;
      line-height: 40px;
    }
    .el-input__suffix,
    .el-input__prefix {
      line-height: 40px;
      .el-input__icon {
        line-height: 40px;
      }
    }
  }
  .btn-info {
    margin-top: 16px;
    .row {
      display: flex;
      align-items: center;
      &:not(:first-child) {
        margin-top: 16px;
      }
      b {
        width: 75px;
        margin-left: 30px;
        margin-right: 30px;
      }
    }
  }
  .el-drawer__header {
    height: 55px;
    min-height: 55px;
    color: #fff;
    margin: 0;
    padding: 0;
  }
  .titleContianer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    .workFlowName {
      width: 100%;
      padding: 0 20px;
      .icon {
        font-size: 24px;
        vertical-align: -2px;
      }
      input {
        width: calc(100% - 54px);
        padding-left: 16px;
        height: 34px;
        line-height: 34px;
        border: none;
        background: transparent;
        border-radius: 3px;
        padding: 0 10px;
        box-sizing: border-box;
        color: #fff;
        margin-left: 5px;
        font-size: 17px;
        &:hover {
          background: hsla(0, 0%, 100%, 0.12);
        }
        &:focus {
          outline: none;
          background: #fff;
          color: #333;
        }
      }
    }
  }
  .el-drawer__close-btn {
    color: #fff;
    position: absolute;
    top: 0;
    right: 10px;
    height: 55px;
    outline: none;
  }
  .content-normal {
    height: calc(100vh - 55px - 65px);
  }
  .content-short {
    height: calc(100vh - 55px - 65px - 150px);
  }
  .content-empty {
    height: calc(100vh - 55px - 65px);
    padding: 20px 20px 30px;
  }
  .content {
    padding: 20px 20px 30px;
    font-size: 14px;
    &::-webkit-scrollbar {
      display: none;
    }
    .trigger {
      .normal-select {
        padding-left: 24px;
      }
    }
    .contentItem {
      font-size: 13px;
      &:not(:first-child) {
        .itemTitle {
          margin-top: 18px;
        }
      }
      .itemTitle {
        font-weight: bold;
        .itemSubTitle {
          margin-left: 5px;
          font-size: 12px;
          cursor: pointer;
          color: #bdbdbd;
          &:hover {
            color: #1e88e5;
          }
        }
        .require-flag {
          color: red;
          font-size: 22px;
          position: relative;
          top: 3px;
        }
      }
      .itemSubTitle {
        margin-top: 10px;
        font-size: 13px;
      }
      .titleTip {
        margin-top: 10px;
        color: #9e9e9e;
      }

      .item-select {
        margin-top: 10px;
      }

      .item-text {
        margin-top: 10px;
      }

      .jump-select {
        margin-top: 10px;
      }
      .radioList {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        .el-radio {
          height: 30px;
          line-height: 30px;
          span {
            font-size: 13px;
          }
          &:not(:last-child) {
            padding-bottom: 5px;
          }
          .el-radio__input.is-checked + .el-radio__label {
            color: #606266;
          }
          .tips {
            height: 30px;
            line-height: 30px;
            color: #9e9e9e;
            padding-left: 24px;
            cursor: text;
            .tipsBtn {
              cursor: pointer;
              color: #1e88e5;
              &:hover {
                color: #1565c0;
              }
            }
          }
        }
        .selectList {
          margin-top: 0;
          width: calc(100% - 26px);
          margin-left: 26px;
          .el-input__inner {
            border: 1px solid #dcdfe6;
            &:hover {
              border-color: #2196f3;
            }
          }
        }
      }

      .workFlowsTipsBtn {
        cursor: pointer;
        color: #1e88e5;
        padding-bottom: 3px;
        &:hover {
          color: #1565c0;
        }
      }

      .workFlows,
      .output-sheet {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 4px;
      }

      .addPeople-container {
        position: relative;
        .addPeople {
          display: inline-flex;
          margin-top: 10px;
          color: #bdbdbd;
          height: 28px;
          cursor: pointer;
          &:hover {
            color: #1e88e5;
            .btn {
              border-color: #1e88e5;
            }
          }
          .btn {
            margin-right: 10px;
            width: 28px;
            height: 28px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px dashed #bdbdbd;
            border-radius: 50%;
            box-sizing: border-box;
          }
          .emptyText {
            line-height: 32px;
          }
        }
      }
      .input-search-container {
        position: relative;
        .input-search {
          margin-top: 10px;
          .el-button {
            padding: 12px;
          }
        }
      }

      .tip-icon {
        font-size: 20px !important;
        font-weight: bold !important;
        &:hover {
          color: #1e88e5;
        }
      }
    }
  }
  .btnContainer {
    border-top: 1px solid #eee;
    text-align: center;
    padding: 12px 0px;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
  }
}
</style>
